import React from 'react';

// Kampanya amacı rozeti — tüm planlarda aynı renk kodu kullanılır
const AMAC_STIL = {
  'Farkındalık': 'bg-red-50 text-red-700 border-red-200',
  'Etkileşim': 'bg-pink-50 text-pink-700 border-pink-200',
  'Trafik': 'bg-sky-50 text-sky-700 border-sky-200',
  'Dönüşüm': 'bg-emerald-50 text-emerald-700 border-emerald-200',
  'Mesaj / DM': 'bg-violet-50 text-violet-700 border-violet-200',
};

function Amac({ tip, not }) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md border text-[11px] font-medium whitespace-nowrap ${AMAC_STIL[tip] || 'bg-gray-50 text-gray-700 border-gray-200'}`}>
      {tip}{not ? ` (${not})` : ''}
    </span>
  );
}

export function HupalupaStoreAgustos2026() {
  return (
    <div className="p-6 max-w-7xl mx-auto">

      {/* ═══════════════════════════════════════════════════════════════════════ */}
      {/* HUPALUPA STORE — ₺450,000 — Ağustos 2026                               */}
      {/* Okula Dönüş · Google Ads + Meta Ads + TikTok Ads                        */}
      {/* Birim maliyetler Temmuz 2026 GERÇEKLEŞEN verisinden türetildi          */}
      {/* ═══════════════════════════════════════════════════════════════════════ */}
      <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
        <div className="bg-white border-b p-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <div className="rounded-lg px-3 py-2">
              <img src="https://hupalupa.store/Data/EditorFiles/Devux/logo-1.svg" alt="Hupalupa Store" className="h-8 w-auto object-contain" />
            </div>
            <div className="ml-1">
              <h2 className="text-lg font-bold text-gray-800">HUPALUPA STORE — Ağustos 2026 Medya Planı</h2>
              <p className="text-sm text-gray-500">Google Ads (PMAX + Search + Shopping + YouTube) • Meta Ads (Catalog + Statik + Etkileşim + Video) • TikTok Ads (Awareness + Engagement + Video Views)</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center px-3 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full border border-gray-200">
              Ağustos 2026
            </span>
            <span className="inline-flex items-center px-3 py-1.5 bg-gray-800 text-white text-sm font-semibold rounded-full">
              Total: ₺450,000
            </span>
          </div>
        </div>

        <div className="p-6">
          {/* Kampanya Odağı */}
          <div className="mb-6 p-4 rounded-xl bg-amber-50 border border-amber-200">
            <p className="text-xs font-semibold text-amber-800 mb-1">Ağustos Odağı — Okula Dönüş</p>
            <p className="text-[11px] text-amber-700 leading-relaxed">
              Ay boyunca tek bir hikâye kurgulanıyor: <strong>okula dönüş ve yeni döneme hazırlık</strong>.
              Store tarafında kırtasiye, çanta-beslenme seti, eğitici oyuncak ve "yeni dönem hediyesi" kategorileri öne çıkarılıyor.
              Talep, Ağustos'un ikinci yarısında hızlanır — bütçenin katalog ve Search bacağı <strong>15 Ağustos sonrasına ağırlıklandırılır</strong>.
              Satış omurgası (Advantage+ Catalog) korunur, üzerine okula dönüş kreatifleriyle statik ve video katmanı eklenir.
            </p>
          </div>

          {/* Temmuz gerçekleşen → Ağustos plan */}
          <div className="mb-6 rounded-xl border border-slate-200 overflow-hidden">
            <div className="bg-slate-100 px-4 py-2.5 text-xs font-semibold text-gray-800">Temmuz 2026 Gerçekleşen → Ağustos 2026 Plan</div>
            <div className="overflow-x-auto">
              <table className="min-w-full text-[11px]">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider">Mecra</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Temmuz Harcama</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Temmuz CPC</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Temmuz CPM</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ağustos Plan</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Değişim</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  <tr>
                    <td className="px-4 py-2 font-medium">Google Ads</td>
                    <td className="px-4 py-2 text-right">₺161,703</td>
                    <td className="px-4 py-2 text-right">₺7.89</td>
                    <td className="px-4 py-2 text-right">₺140</td>
                    <td className="px-4 py-2 text-right font-semibold">₺195,000</td>
                    <td className="px-4 py-2 text-right text-emerald-600">+21%</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">Meta Ads</td>
                    <td className="px-4 py-2 text-right">₺214,590</td>
                    <td className="px-4 py-2 text-right">₺3.84</td>
                    <td className="px-4 py-2 text-right">₺115</td>
                    <td className="px-4 py-2 text-right font-semibold">₺230,000</td>
                    <td className="px-4 py-2 text-right text-emerald-600">+7%</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">TikTok Ads</td>
                    <td className="px-4 py-2 text-right text-gray-400">₺0 (yayında değil)</td>
                    <td className="px-4 py-2 text-right text-gray-400">-</td>
                    <td className="px-4 py-2 text-right text-gray-400">-</td>
                    <td className="px-4 py-2 text-right font-semibold">₺25,000</td>
                    <td className="px-4 py-2 text-right text-blue-600">yeni</td>
                  </tr>
                  <tr className="bg-gray-50 font-semibold text-gray-800">
                    <td className="px-4 py-2">Toplam</td>
                    <td className="px-4 py-2 text-right">₺376,293</td>
                    <td className="px-4 py-2 text-right">₺4.93</td>
                    <td className="px-4 py-2 text-right">-</td>
                    <td className="px-4 py-2 text-right">₺450,000</td>
                    <td className="px-4 py-2 text-right text-emerald-700">+20%</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="px-4 py-2.5 bg-blue-50 border-t border-blue-100 text-[11px] text-blue-800">
              Temmuz'da Google tarafında <strong>144 dönüşüm / ₺595,743 dönüşüm değeri</strong> raporlandı — Google ROAS <strong>3.68</strong>, dönüşüm başı maliyet <strong>₺1,123</strong>.
              Ağustos hedefi bu ROAS'ı korurken bütçeyi %20 büyütmek.
            </div>
          </div>

          {/* AMAÇ BAZLI BÜTÇE DAĞILIMI */}
          <div className="rounded-xl border overflow-hidden mb-6">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Kampanya Amacına Göre Bütçe Dağılımı</div>
            {/* oran şeridi */}
            <div className="px-4 pt-4">
              <div className="flex w-full h-3 rounded-full overflow-hidden border border-gray-200">
                <div className="bg-emerald-400" style={{ width: '81.8%' }} title="Dönüşüm %82" />
                <div className="bg-red-400" style={{ width: '11.3%' }} title="Farkındalık %11" />
                <div className="bg-pink-400" style={{ width: '6.9%' }} title="Etkileşim %7" />
              </div>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full text-[12px] mt-3">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider text-[11px]">Amaç</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider text-[11px]">Bütçe</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider text-[11px]">Pay</th>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider text-[11px]">Ana Mecralar</th>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider text-[11px]">Hedeflenen Çıktı</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  <tr>
                    <td className="px-4 py-2.5"><Amac tip="Dönüşüm" not="satış" /></td>
                    <td className="px-4 py-2.5 text-right font-semibold">₺368,000</td>
                    <td className="px-4 py-2.5 text-right">82%</td>
                    <td className="px-4 py-2.5">Google PMAX · Search · Shopping · DSA · Meta Advantage+ Catalog · Statik</td>
                    <td className="px-4 py-2.5">81,068 satış odaklı tıklama · hedef ROAS 3.5+</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2.5"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-2.5 text-right font-semibold">₺51,000</td>
                    <td className="px-4 py-2.5 text-right">11%</td>
                    <td className="px-4 py-2.5">Google YouTube · Meta Video Views · TikTok Awareness + Video Views</td>
                    <td className="px-4 py-2.5">522,222 video izlenme · 1.99M gösterim</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2.5"><Amac tip="Etkileşim" /></td>
                    <td className="px-4 py-2.5 text-right font-semibold">₺31,000</td>
                    <td className="px-4 py-2.5 text-right">7%</td>
                    <td className="px-4 py-2.5">Meta Post Engagement · TikTok Engagement</td>
                    <td className="px-4 py-2.5">~28,750 etkileşim · 825K gösterim</td>
                  </tr>
                  <tr className="bg-gray-50 font-semibold text-gray-800">
                    <td className="px-4 py-2.5">Toplam</td>
                    <td className="px-4 py-2.5 text-right">₺450,000</td>
                    <td className="px-4 py-2.5 text-right">100%</td>
                    <td className="px-4 py-2.5">3 mecra · 14 kampanya</td>
                    <td className="px-4 py-2.5">84,068 tıklama · 522K izlenme · 28.7K etkileşim · 5.36M gösterim</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="px-4 py-2.5 bg-emerald-50 border-t border-emerald-100 text-[11px] text-emerald-800">
              Store bir <strong>e-ticaret markası</strong> olduğu için ağırlık dönüşümde: bütçenin %82'si doğrudan satışa çalışıyor.
              Farkındalık ve etkileşim bacağı (%18) marka talebini büyütmek ve dönüşüm kampanyalarına retargeting havuzu üretmek için var —
              bu havuzun getirisi aynı ay değil, Eylül-Ekim'de ölçülür.
            </div>
          </div>

          {/* Mecra Özeti */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
            <div className="rounded-xl border border-blue-100 bg-blue-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/google_ads-512.webp" alt="Google" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-blue-700">Google Ads</span>
              </div>
              <p className="text-xl font-bold text-blue-800">₺195,000</p>
              <p className="text-[10px] text-blue-600 mt-0.5">43% • PMAX + Search + Shopping + YouTube</p>
            </div>
            <div className="rounded-xl border border-indigo-100 bg-indigo-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-indigo-700">Meta Ads</span>
              </div>
              <p className="text-xl font-bold text-indigo-800">₺230,000</p>
              <p className="text-[10px] text-indigo-600 mt-0.5">51% • Catalog + Statik + Etkileşim + Video</p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/tiktokv4.svg" alt="TikTok" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-gray-700">TikTok Ads</span>
              </div>
              <p className="text-xl font-bold text-gray-800">₺25,000</p>
              <p className="text-[10px] text-gray-600 mt-0.5">6% • Awareness + Engagement + Video Views</p>
            </div>
            <div className="rounded-xl border border-emerald-100 bg-emerald-50 p-4">
              <span className="text-xs font-medium text-emerald-700">Toplam Tıklama</span>
              <p className="text-xl font-bold text-emerald-800">84.1K</p>
              <p className="text-[10px] text-emerald-600 mt-0.5">Google 30.1K + Meta 54.0K</p>
            </div>
            <div className="rounded-xl border border-red-100 bg-red-50 p-4">
              <span className="text-xs font-medium text-red-700">Toplam İzlenme</span>
              <p className="text-xl font-bold text-red-800">522K</p>
              <p className="text-[10px] text-red-600 mt-0.5">YouTube 100K + Meta 222K + TikTok 200K</p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
              <span className="text-xs font-medium text-gray-700">Tahmini Erişim*</span>
              <p className="text-xl font-bold text-gray-800">~1.8M</p>
              <p className="text-[10px] text-gray-600 mt-0.5">5.36M gösterim · ort. frekans ~3.0</p>
            </div>
          </div>

          {/* ANA PLAN TABLOSU */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Medya Planı — HUPALUPA STORE Ağustos 2026</div>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Mecra</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Kampanya</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Hedef Kitle</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amaç</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tahmini Çıktı</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Bütçe</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-[12px] text-gray-700">
                  {/* Google Ads */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium align-top" rowSpan={6}>
                      <div className="flex items-center gap-2">
                        <img src="/google_ads-512.webp" alt="Google Ads" className="w-5 h-5 object-contain" />
                        <span>Google Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3">Performance Max — Okula Dönüş</td>
                    <td className="px-4 py-3">Geniş + alışveriş sinyalli · 25-45 ebeveyn · okul alışverişi yapan</td>
                    <td className="px-4 py-3"><Amac tip="Dönüşüm" /></td>
                    <td className="px-4 py-3">990,000 gösterim · 11,875 tıklama · ₺8.0 CPC</td>
                    <td className="px-4 py-3 text-right font-medium">₺95,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Search — Branding</td>
                    <td className="px-4 py-3">Markayı adıyla arayanlar (Hupalupa / hupalupa.store)</td>
                    <td className="px-4 py-3"><Amac tip="Dönüşüm" /></td>
                    <td className="px-4 py-3">9,100 gösterim · 3,077 tıklama · ₺13.0 CPC</td>
                    <td className="px-4 py-3 text-right font-medium">₺40,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Search — Generic (Okula Dönüş)</td>
                    <td className="px-4 py-3">"okul çantası", "beslenme seti", "kırtasiye seti", "eğitici oyuncak" arayanlar</td>
                    <td className="px-4 py-3"><Amac tip="Dönüşüm" /></td>
                    <td className="px-4 py-3">55,000 gösterim · 3,846 tıklama · ₺6.5 CPC</td>
                    <td className="px-4 py-3 text-right font-medium">₺25,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Dynamic Search Ads (DSA)</td>
                    <td className="px-4 py-3">Site içeriğiyle eşleşen uzun kuyruk aramalar</td>
                    <td className="px-4 py-3"><Amac tip="Dönüşüm" /></td>
                    <td className="px-4 py-3">33,000 gösterim · 2,381 tıklama · ₺6.3 CPC</td>
                    <td className="px-4 py-3 text-right font-medium">₺15,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Shopping (All Products)</td>
                    <td className="px-4 py-3">Ürün adı / kategori arayan alışveriş niyetli kullanıcı</td>
                    <td className="px-4 py-3"><Amac tip="Dönüşüm" /></td>
                    <td className="px-4 py-3">216,000 gösterim · 8,889 tıklama · ₺0.9 CPC</td>
                    <td className="px-4 py-3 text-right font-medium">₺8,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">YouTube Video — Okula Dönüş</td>
                    <td className="px-4 py-3">25-45 ebeveyn · aile, çocuk, eğitim içeriği izleyicileri</td>
                    <td className="px-4 py-3"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-3">370,000 gösterim · 100,000 izlenme · ₺0.12 CPV</td>
                    <td className="px-4 py-3 text-right font-medium">₺12,000</td>
                  </tr>
                  <tr className="bg-blue-50 font-semibold text-blue-800">
                    <td className="px-4 py-3" colSpan={4}>Google Ads Toplam</td>
                    <td className="px-4 py-3">1,673,100 gösterim · 30,068 tıklama · 100K izlenme</td>
                    <td className="px-4 py-3 text-right">₺195,000</td>
                  </tr>

                  {/* Meta Ads */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium align-top" rowSpan={5}>
                      <div className="flex items-center gap-2">
                        <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                        <span>Meta Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3">Sales — Advantage+ Catalog (Okula Dönüş)</td>
                    <td className="px-4 py-3">Geniş prospecting · 25-45 ebeveyn · katalog satın alma sinyali</td>
                    <td className="px-4 py-3"><Amac tip="Dönüşüm" /></td>
                    <td className="px-4 py-3">863,000 gösterim · 37,500 tıklama · ₺3.2 CPC</td>
                    <td className="px-4 py-3 text-right font-medium">₺120,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Catalog Remarketing (Kategori + Ürün)</td>
                    <td className="px-4 py-3">Son 30 gün ürün görüntüleyen / sepete ekleyen / satın almayan</td>
                    <td className="px-4 py-3"><Amac tip="Dönüşüm" /></td>
                    <td className="px-4 py-3">216,000 gösterim · 10,000 tıklama · ₺3.0 CPC</td>
                    <td className="px-4 py-3 text-right font-medium">₺30,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Sales — Statik (Okula Dönüş kreatifleri)</td>
                    <td className="px-4 py-3">Okula dönüş ilgi alanları · Lookalike %1-3 (satın alanlar)</td>
                    <td className="px-4 py-3"><Amac tip="Dönüşüm" /></td>
                    <td className="px-4 py-3">160,000 gösterim · 3,500 tıklama · ₺10.0 CPC</td>
                    <td className="px-4 py-3 text-right font-medium">₺35,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Post Engagement</td>
                    <td className="px-4 py-3">Geniş ebeveyn kitlesi + sayfa/reklam etkileşimcileri</td>
                    <td className="px-4 py-3"><Amac tip="Etkileşim" /></td>
                    <td className="px-4 py-3">625,000 gösterim · ~18,750 etkileşim · 3,000 tıklama</td>
                    <td className="px-4 py-3 text-right font-medium">₺25,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Video Views — Okula Dönüş filmi</td>
                    <td className="px-4 py-3">Geniş prospecting 25-45 · çocuk/aile ilgi alanları</td>
                    <td className="px-4 py-3"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-3">560,000 gösterim · 222,222 izlenme · ₺0.09 CPV</td>
                    <td className="px-4 py-3 text-right font-medium">₺20,000</td>
                  </tr>
                  <tr className="bg-indigo-50 font-semibold text-indigo-800">
                    <td className="px-4 py-3" colSpan={4}>Meta Ads Toplam</td>
                    <td className="px-4 py-3">2,424,000 gösterim · 54,000 tıklama · 222K izlenme · 18.7K etkileşim</td>
                    <td className="px-4 py-3 text-right">₺230,000</td>
                  </tr>

                  {/* TikTok Ads */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium align-top" rowSpan={3}>
                      <div className="flex items-center gap-2">
                        <img src="/tiktokv4.svg" alt="TikTok" className="w-5 h-5 object-contain" />
                        <span>TikTok Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3">Awareness</td>
                    <td className="px-4 py-3">25-45 ebeveyn · geniş bölgesel erişim</td>
                    <td className="px-4 py-3"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-3">583,000 gösterim · ~390,000 erişim · ₺12 CPM</td>
                    <td className="px-4 py-3 text-right font-medium">₺7,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Engagement</td>
                    <td className="px-4 py-3">Oyuncak / çocuk ürünleri içerik izleyicileri + video izleyenler</td>
                    <td className="px-4 py-3"><Amac tip="Etkileşim" /></td>
                    <td className="px-4 py-3">200,000 gösterim · ~10,000 etkileşim · ₺30 CPM</td>
                    <td className="px-4 py-3 text-right font-medium">₺6,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Video Views</td>
                    <td className="px-4 py-3">25-45 ebeveyn · oyuncak, çocuk ürünleri içerik izleyicileri</td>
                    <td className="px-4 py-3"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-3">480,000 gösterim · 200,000 izlenme · ₺25 CPM · ₺0.06 CPV</td>
                    <td className="px-4 py-3 text-right font-medium">₺12,000</td>
                  </tr>
                  <tr className="bg-gray-100 font-semibold text-gray-800">
                    <td className="px-4 py-3" colSpan={4}>TikTok Ads Toplam</td>
                    <td className="px-4 py-3">1,263,000 gösterim · 200K izlenme · ~10K etkileşim</td>
                    <td className="px-4 py-3 text-right">₺25,000</td>
                  </tr>

                  {/* Grand Total */}
                  <tr className="bg-gray-800 text-white font-bold">
                    <td className="px-4 py-3" colSpan={4}>GENEL TOPLAM</td>
                    <td className="px-4 py-3">5,360,100 gösterim · 84,068 tıklama · 522K izlenme · ~28.7K etkileşim</td>
                    <td className="px-4 py-3 text-right">₺450,000</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Ay içi takvim */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Ay İçi Bütçe Takvimi — Okula Dönüş İvmesi</div>
            <div className="p-5 grid grid-cols-1 md:grid-cols-3 gap-4 text-[12px] text-gray-700">
              <div className="rounded-lg border border-gray-200 bg-gray-50 p-3">
                <p className="font-semibold text-gray-800 mb-1">1-10 Ağustos — Hazırlık (%25 • ₺112K)</p>
                <p className="leading-relaxed">Okula dönüş kreatifleri yayına alınır, video ve etkileşim kampanyaları erişim havuzunu büyütür. Katalog normal seviyede döner, yaz stoğu eritme devam eder.</p>
              </div>
              <div className="rounded-lg border border-amber-200 bg-amber-50 p-3">
                <p className="font-semibold text-amber-800 mb-1">11-22 Ağustos — Yükseliş (%40 • ₺180K)</p>
                <p className="leading-relaxed">Arama talebi hızlanır: Search Generic ve Shopping teklifleri artırılır, PMAX'e okula dönüş asset grubu eklenir. Video izleyicileri katalog kampanyalarına retargeting kaynağı olur.</p>
              </div>
              <div className="rounded-lg border border-rose-200 bg-rose-50 p-3">
                <p className="font-semibold text-rose-800 mb-1">23-31 Ağustos — Zirve (%35 • ₺158K)</p>
                <p className="leading-relaxed">Okul açılışına son hafta: katalog + remarketing ağırlığı en üst seviyede, kargo/teslimat vaadi kreatife taşınır. Statik "son gün" iletişimi devreye girer.</p>
              </div>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="p-4 rounded-xl bg-amber-50 border border-amber-200">
            <div className="flex items-start gap-2.5">
              <div className="flex-shrink-0 mt-0.5">
                <svg className="w-4 h-4 text-amber-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <p className="text-xs font-semibold text-amber-800">Projeksiyon Notu</p>
                <p className="text-[11px] text-amber-700 mt-1 leading-relaxed">
                  Bu plandaki CPC ve CPM değerleri, hesabın <strong>Temmuz 2026 gerçekleşen verisinden</strong> türetilmiştir (Google ₺7.89 CPC / ₺140 CPM · Meta ₺3.84 CPC / ₺115 CPM);
                  her kampanya kendi geçmiş birim maliyetiyle projekte edilmiştir. TikTok satırları hesapta henüz harcama olmadığı için <strong>pazar benchmark'ıdır</strong> (Awareness ₺12 CPM · Engagement ₺30 CPM · Video Views ₺25 CPM).
                  TikTok'ta trafik kampanyası yok — mecra video ve erişim üretmek için kullanılıyor, tıklama Google ve Meta'dan geliyor.
                  <strong> *Tahmini erişim</strong> platform içi tekilleştirmeye dayanır; platformlar arası çakışma ölçülemediği için tekil kişi sayısı bu rakamdan düşüktür.
                  Dönüşüm adedi ve ciro projeksiyonu verilmemiştir — Temmuz'da gerçekleşen ROAS 3.68'dir ve hedef bunun korunmasıdır, ancak
                  stok, fiyat ve kampanya koşulları sonucu doğrudan etkilediği için taahhüt edilemez.
                  Okula dönüş döneminde rekabet arttığı için birim maliyetlerde <strong>%10-20 yukarı sapma</strong> beklenebilir; bu durumda tıklama tahminleri aynı oranda geriler.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export function HupalupaEglenceAgustos2026() {
  return (
    <div className="p-6 max-w-7xl mx-auto">

      {/* ═══════════════════════════════════════════════════════════════════════ */}
      {/* HUPALUPA (Eğlence) — ₺300,000 — Ağustos 2026                           */}
      {/* Okula dönüş + yeni sezon atölye kayıtları                              */}
      {/* Birim maliyetler Temmuz 2026 GERÇEKLEŞEN verisinden türetildi          */}
      {/* ═══════════════════════════════════════════════════════════════════════ */}
      <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
        <div className="bg-white border-b p-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <div className="rounded-lg px-3 py-1.5">
              <img src="https://hupalupa.com.tr/images/logo_s.png" alt="Hupalupa" className="h-8 w-auto object-contain" />
            </div>
            <div className="ml-1">
              <h2 className="text-lg font-bold text-gray-800">HUPALUPA — Ağustos 2026 Medya Planı</h2>
              <p className="text-sm text-gray-500">Google Ads (Search + YouTube) • Meta Ads (Awareness + Engagement + Video Views) • TikTok Ads (Awareness + Engagement + Video Views)</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center px-3 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full border border-gray-200">
              Ağustos 2026
            </span>
            <span className="inline-flex items-center px-3 py-1.5 bg-gray-800 text-white text-sm font-semibold rounded-full">
              Total: ₺300,000
            </span>
          </div>
        </div>

        <div className="p-6">
          {/* Kampanya Odağı */}
          <div className="mb-6 p-4 rounded-xl bg-violet-50 border border-violet-200">
            <p className="text-xs font-semibold text-violet-800 mb-1">Ağustos Odağı — Okula Dönüş &amp; Yeni Sezon Atölye Kayıtları</p>
            <p className="text-[11px] text-violet-700 leading-relaxed">
              Ağustos, eğlence tarafında <strong>iki işi aynı anda</strong> yapıyor: (1) yaz tatilinin son ayında oyun alanı ziyaretini yüksek tutmak,
              (2) <strong>Eylül dönem atölye kayıtlarını</strong> şimdiden toplamak. Meta tarafı üç kampanya amacına indirgendi — <strong>Awareness · Engagement · Video Views</strong>:
              "okula dönüş öncesi son eğlence" mesajı erişim ve etkileşim kampanyalarını, "yeni sezon atölye programı" mesajı ise
              awareness ve video kampanyalarını besler. Kayıt niyeti Google Generic Search'te toplanır. Doğum günü ve grup rezervasyonu sürekli akan ikinci talep kaynağıdır.
            </p>
          </div>

          {/* Temmuz gerçekleşen → Ağustos plan */}
          <div className="mb-6 rounded-xl border border-slate-200 overflow-hidden">
            <div className="bg-slate-100 px-4 py-2.5 text-xs font-semibold text-gray-800">Temmuz 2026 Gerçekleşen → Ağustos 2026 Plan</div>
            <div className="overflow-x-auto">
              <table className="min-w-full text-[11px]">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider">Mecra</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Temmuz Harcama</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Temmuz CPC</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Temmuz CPM</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ağustos Plan</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Değişim</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  <tr>
                    <td className="px-4 py-2 font-medium">Google Ads</td>
                    <td className="px-4 py-2 text-right">₺130,281</td>
                    <td className="px-4 py-2 text-right">₺1.82</td>
                    <td className="px-4 py-2 text-right">₺55</td>
                    <td className="px-4 py-2 text-right font-semibold">₺120,000</td>
                    <td className="px-4 py-2 text-right text-rose-600">-8%</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">Meta Ads</td>
                    <td className="px-4 py-2 text-right">₺171,580</td>
                    <td className="px-4 py-2 text-right">₺6.45</td>
                    <td className="px-4 py-2 text-right">₺30</td>
                    <td className="px-4 py-2 text-right font-semibold">₺160,000</td>
                    <td className="px-4 py-2 text-right text-rose-600">-7%</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">TikTok Ads</td>
                    <td className="px-4 py-2 text-right text-gray-400">₺0 (yayında değil)</td>
                    <td className="px-4 py-2 text-right text-gray-400">-</td>
                    <td className="px-4 py-2 text-right text-gray-400">-</td>
                    <td className="px-4 py-2 text-right font-semibold">₺20,000</td>
                    <td className="px-4 py-2 text-right text-blue-600">yeni</td>
                  </tr>
                  <tr className="bg-gray-50 font-semibold text-gray-800">
                    <td className="px-4 py-2">Toplam</td>
                    <td className="px-4 py-2 text-right">₺301,861</td>
                    <td className="px-4 py-2 text-right">₺3.08</td>
                    <td className="px-4 py-2 text-right">-</td>
                    <td className="px-4 py-2 text-right">₺300,000</td>
                    <td className="px-4 py-2 text-right text-gray-600">≈ aynı</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="px-4 py-2.5 bg-amber-50 border-t border-amber-100 text-[11px] text-amber-800">
              <strong>Dikkat:</strong> Temmuz'daki ₺1.82 ortalama Google CPC'si GDN kampanyasının şişirdiği bir ortalamadır
              (Hupalupa_GDN_AO: ₺12,961 harcama · 52,971 tıklama · ₺0.24 CPC — niyet taşımayan tıklama).
              <strong> Ağustos planında Display/GDN yer almıyor</strong>; bütçesi Generic Search ve YouTube'a aktarıldı.
              Niyet taşıyan tıklamanın gerçek maliyeti <strong>Brand Search ₺5.97</strong> ve <strong>Generic Search ₺3.13</strong> seviyesindedir; plan bu ikisine göre kurulmuştur.
            </div>
          </div>

          {/* AMAÇ BAZLI BÜTÇE DAĞILIMI */}
          <div className="rounded-xl border overflow-hidden mb-6">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Kampanya Amacına Göre Bütçe Dağılımı</div>
            <div className="px-4 pt-4">
              <div className="flex w-full h-3 rounded-full overflow-hidden border border-gray-200">
                <div className="bg-red-400" style={{ width: '47.3%' }} title="Farkındalık %47" />
                <div className="bg-pink-400" style={{ width: '27%' }} title="Etkileşim %27" />
                <div className="bg-sky-400" style={{ width: '15%' }} title="Trafik %15" />
                <div className="bg-emerald-400" style={{ width: '10.7%' }} title="Dönüşüm %11" />
              </div>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full text-[12px] mt-3">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider text-[11px]">Amaç</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider text-[11px]">Bütçe</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider text-[11px]">Pay</th>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider text-[11px]">Ana Mecralar</th>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider text-[11px]">Hedeflenen Çıktı</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  <tr>
                    <td className="px-4 py-2.5"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-2.5 text-right font-semibold">₺142,000</td>
                    <td className="px-4 py-2.5 text-right">47%</td>
                    <td className="px-4 py-2.5">Meta Awareness + Video Views · Google YouTube · TikTok Awareness + Video Views</td>
                    <td className="px-4 py-2.5">522,222 izlenme · 8.67M gösterim</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2.5"><Amac tip="Etkileşim" /></td>
                    <td className="px-4 py-2.5 text-right font-semibold">₺81,000</td>
                    <td className="px-4 py-2.5 text-right">27%</td>
                    <td className="px-4 py-2.5">Meta Engagement · TikTok Engagement</td>
                    <td className="px-4 py-2.5">~60,000 etkileşim · 12,821 tıklama · 1.87M gösterim</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2.5"><Amac tip="Trafik" /></td>
                    <td className="px-4 py-2.5 text-right font-semibold">₺45,000</td>
                    <td className="px-4 py-2.5 text-right">15%</td>
                    <td className="px-4 py-2.5">Google Brand Search</td>
                    <td className="px-4 py-2.5">7,500 tıklama</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2.5"><Amac tip="Dönüşüm" not="kayıt/rezervasyon" /></td>
                    <td className="px-4 py-2.5 text-right font-semibold">₺32,000</td>
                    <td className="px-4 py-2.5 text-right">11%</td>
                    <td className="px-4 py-2.5">Google Generic Search</td>
                    <td className="px-4 py-2.5">10,000 yüksek niyetli tıklama</td>
                  </tr>
                  <tr className="bg-gray-50 font-semibold text-gray-800">
                    <td className="px-4 py-2.5">Toplam</td>
                    <td className="px-4 py-2.5 text-right">₺300,000</td>
                    <td className="px-4 py-2.5 text-right">100%</td>
                    <td className="px-4 py-2.5">3 mecra · 9 kampanya</td>
                    <td className="px-4 py-2.5">39,651 tıklama · 522K izlenme · 60K etkileşim · 10.87M gösterim</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="px-4 py-2.5 bg-violet-50 border-t border-violet-100 text-[11px] text-violet-800">
              Store'un tersine burada ağırlık <strong>farkındalık ve etkileşimde</strong> (%74): fiziksel bir mekân satıldığı için önce
              "aklına gelmek" gerekiyor, satış anı ise mekânda gerçekleşiyor.
              ⚠️ Meta tarafı üç amaca (Awareness · Engagement · Video Views) indirgendiği için <strong>mesaj/DM kampanyası bu planda yok</strong>;
              ölçülebilir tek kayıt sinyali <strong>Google Generic Search</strong> bacağıdır — Display'den boşalan bütçeyle ₺32K'ya (%11) çıkarıldı.
            </div>
          </div>

          {/* Mecra Özeti */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
            <div className="rounded-xl border border-blue-100 bg-blue-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/google_ads-512.webp" alt="Google" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-blue-700">Google Ads</span>
              </div>
              <p className="text-xl font-bold text-blue-800">₺120,000</p>
              <p className="text-[10px] text-blue-600 mt-0.5">40% • Brand + Generic Search + YouTube</p>
            </div>
            <div className="rounded-xl border border-indigo-100 bg-indigo-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-indigo-700">Meta Ads</span>
              </div>
              <p className="text-xl font-bold text-indigo-800">₺160,000</p>
              <p className="text-[10px] text-indigo-600 mt-0.5">53% • Awareness + Engagement + Video Views</p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/tiktokv4.svg" alt="TikTok" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-gray-700">TikTok Ads</span>
              </div>
              <p className="text-xl font-bold text-gray-800">₺20,000</p>
              <p className="text-[10px] text-gray-600 mt-0.5">7% • Awareness + Engagement + Video Views</p>
            </div>
            <div className="rounded-xl border border-emerald-100 bg-emerald-50 p-4">
              <span className="text-xs font-medium text-emerald-700">Toplam Tıklama</span>
              <p className="text-xl font-bold text-emerald-800">39.7K</p>
              <p className="text-[10px] text-emerald-600 mt-0.5">Display kaldırıldı • tamamı niyetli</p>
            </div>
            <div className="rounded-xl border border-red-100 bg-red-50 p-4">
              <span className="text-xs font-medium text-red-700">Toplam İzlenme</span>
              <p className="text-xl font-bold text-red-800">522K</p>
              <p className="text-[10px] text-red-600 mt-0.5">Meta 389K + TikTok 133K</p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
              <span className="text-xs font-medium text-gray-700">Tahmini Erişim*</span>
              <p className="text-xl font-bold text-gray-800">~2.7M</p>
              <p className="text-[10px] text-gray-600 mt-0.5">10.87M gösterim · ort. frekans ~4.0</p>
            </div>
          </div>

          {/* ANA PLAN TABLOSU */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Medya Planı — HUPALUPA Ağustos 2026</div>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Mecra</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Kampanya</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Hedef Kitle</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amaç</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tahmini Çıktı</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Bütçe</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-[12px] text-gray-700">
                  {/* Google Ads */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium align-top" rowSpan={3}>
                      <div className="flex items-center gap-2">
                        <img src="/google_ads-512.webp" alt="Google Ads" className="w-5 h-5 object-contain" />
                        <span>Google Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3">Search — Brand (HUPALUPA)</td>
                    <td className="px-4 py-3">Markayı adıyla arayanlar · şube adı + "hupalupa" varyasyonları</td>
                    <td className="px-4 py-3"><Amac tip="Trafik" /></td>
                    <td className="px-4 py-3">35,000 gösterim · 7,500 tıklama · ₺6.0 CPC</td>
                    <td className="px-4 py-3 text-right font-medium">₺45,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Search — Generic</td>
                    <td className="px-4 py-3">"çocuk oyun alanı", "doğum günü organizasyonu", "çocuk atölyesi" arayanlar · şube çevresi</td>
                    <td className="px-4 py-3"><Amac tip="Dönüşüm" not="kayıt" /></td>
                    <td className="px-4 py-3">294,000 gösterim · 10,000 tıklama · ₺3.2 CPC</td>
                    <td className="px-4 py-3 text-right font-medium">₺32,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">YouTube — Video Efficient Reach (Yeni Sezon)</td>
                    <td className="px-4 py-3">25-45 ebeveyn · şube çevresi · çocuk/aile içerik izleyicileri</td>
                    <td className="px-4 py-3"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-3">1,870,000 gösterim · ~2,330 tıklama · ₺23 CPM</td>
                    <td className="px-4 py-3 text-right font-medium">₺43,000</td>
                  </tr>
                  <tr className="bg-blue-50 font-semibold text-blue-800">
                    <td className="px-4 py-3" colSpan={4}>Google Ads Toplam</td>
                    <td className="px-4 py-3">2,199,000 gösterim · 19,830 tıklama</td>
                    <td className="px-4 py-3 text-right">₺120,000</td>
                  </tr>

                  {/* Meta Ads */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium align-top" rowSpan={3}>
                      <div className="flex items-center gap-2">
                        <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                        <span>Meta Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3">Awareness</td>
                    <td className="px-4 py-3">Geniş erişim · şube çevresi ebeveyn kitlesi · çocuklu hane</td>
                    <td className="px-4 py-3"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-3">5,000,000 gösterim · ~1.5M erişim · 7,000 tıklama · ₺10 CPM</td>
                    <td className="px-4 py-3 text-right font-medium">₺50,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Engagement</td>
                    <td className="px-4 py-3">25-45 ebeveyn · şube çevresi 0-20 km · çocuklu hane + sayfa etkileşimcileri</td>
                    <td className="px-4 py-3"><Amac tip="Etkileşim" /></td>
                    <td className="px-4 py-3">1,667,000 gösterim · ~50,000 etkileşim · 12,821 tıklama · ₺45 CPM</td>
                    <td className="px-4 py-3 text-right font-medium">₺75,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Video Views</td>
                    <td className="px-4 py-3">Geniş prospecting · bölgesel 25-45 · çocuk/aile ilgi alanları</td>
                    <td className="px-4 py-3"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-3">980,000 gösterim · 388,889 izlenme · ₺0.09 CPV</td>
                    <td className="px-4 py-3 text-right font-medium">₺35,000</td>
                  </tr>
                  <tr className="bg-indigo-50 font-semibold text-indigo-800">
                    <td className="px-4 py-3" colSpan={4}>Meta Ads Toplam</td>
                    <td className="px-4 py-3">7,647,000 gösterim · 19,821 tıklama · 389K izlenme · ~50K etkileşim</td>
                    <td className="px-4 py-3 text-right">₺160,000</td>
                  </tr>

                  {/* TikTok Ads */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium align-top" rowSpan={3}>
                      <div className="flex items-center gap-2">
                        <img src="/tiktokv4.svg" alt="TikTok" className="w-5 h-5 object-contain" />
                        <span>TikTok Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3">Awareness</td>
                    <td className="px-4 py-3">Şube çevresi ebeveyn · geniş erişim</td>
                    <td className="px-4 py-3"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-3">500,000 gösterim · ~330,000 erişim · ₺12 CPM</td>
                    <td className="px-4 py-3 text-right font-medium">₺6,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Engagement</td>
                    <td className="px-4 py-3">Şube çevresi ebeveyn + video izleyenler · çocuk aktivitesi içerik izleyicileri</td>
                    <td className="px-4 py-3"><Amac tip="Etkileşim" /></td>
                    <td className="px-4 py-3">200,000 gösterim · ~10,000 etkileşim · ₺30 CPM</td>
                    <td className="px-4 py-3 text-right font-medium">₺6,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Video Views</td>
                    <td className="px-4 py-3">Şube çevresi ebeveyn · çocuk aktivitesi içerik izleyicileri</td>
                    <td className="px-4 py-3"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-3">320,000 gösterim · 133,333 izlenme · ₺25 CPM · ₺0.06 CPV</td>
                    <td className="px-4 py-3 text-right font-medium">₺8,000</td>
                  </tr>
                  <tr className="bg-gray-100 font-semibold text-gray-800">
                    <td className="px-4 py-3" colSpan={4}>TikTok Ads Toplam</td>
                    <td className="px-4 py-3">1,020,000 gösterim · 133K izlenme · ~10K etkileşim</td>
                    <td className="px-4 py-3 text-right">₺20,000</td>
                  </tr>

                  {/* Grand Total */}
                  <tr className="bg-gray-800 text-white font-bold">
                    <td className="px-4 py-3" colSpan={4}>GENEL TOPLAM</td>
                    <td className="px-4 py-3">10,866,000 gösterim · 39,651 tıklama · 522K izlenme · ~60K etkileşim</td>
                    <td className="px-4 py-3 text-right">₺300,000</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Hedefleme & Strateji */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Hedefleme &amp; Strateji — HUPALUPA</div>
            <div className="p-5 grid grid-cols-1 md:grid-cols-3 gap-4 text-[12px] text-gray-700">
              <div className="rounded-lg border border-violet-100 bg-violet-50/40 p-3">
                <p className="font-semibold text-violet-800 mb-1">Yeni Sezon Atölye Kaydı</p>
                <p className="leading-relaxed">Eylül dönemi atölye programı <strong>Awareness</strong> kampanyasıyla geniş kitleye duyurulur, ilgi <strong>Engagement</strong> ile derinleştirilir. 3-10 yaş çocuk ebeveyni, şube çevresi lokasyon kırılımı; erken kayıt avantajı mesajı. Kayıt niyeti Generic Search'te toplanır.</p>
              </div>
              <div className="rounded-lg border border-amber-100 bg-amber-50/40 p-3">
                <p className="font-semibold text-amber-800 mb-1">Tatilin Son Ayı — Ziyaret</p>
                <p className="leading-relaxed">Meta <strong>Awareness</strong> ve <strong>Engagement</strong> ile geniş erişim; "okul açılmadan son eğlence" mesajı. Hafta içi gündüz saatleri (düşük doluluk) ayrı bütçe dilimiyle desteklenir.</p>
              </div>
              <div className="rounded-lg border border-sky-100 bg-sky-50/40 p-3">
                <p className="font-semibold text-sky-800 mb-1">Doğum Günü &amp; Grup Rezervasyonu</p>
                <p className="leading-relaxed">Generic Search'te "doğum günü organizasyonu", "çocuk parti mekânı" gibi yüksek niyetli aramalar; lokasyon kısıtlı ve mesaj/form dönüşümü odaklı.</p>
              </div>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="p-4 rounded-xl bg-amber-50 border border-amber-200">
            <div className="flex items-start gap-2.5">
              <div className="flex-shrink-0 mt-0.5">
                <svg className="w-4 h-4 text-amber-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <p className="text-xs font-semibold text-amber-800">Projeksiyon Notu</p>
                <p className="text-[11px] text-amber-700 mt-1 leading-relaxed">
                  Birim maliyetler hesabın <strong>Temmuz 2026 gerçekleşen kampanya verisinden</strong> alınmıştır: Brand Search ₺5.97 CPC · Generic Search ₺3.13 CPC ·
                  YouTube ₺23 CPM · Meta Engagement ₺45 CPM · Video ₺0.09 CPV. TikTok satırları benchmark'tır (Awareness ₺12 CPM · Engagement ₺30 CPM · Video Views ₺25 CPM);
                  TikTok'ta trafik kampanyası yoktur. Meta <strong>Awareness</strong> satırı ₺10 CPM ile projekte edilmiştir —
                  Temmuz'daki geniş erişim kampanyası ₺7.45 CPM ile dönmüştü, ölçek büyüdüğü için ihtiyatlı davranıldı. TikTok satırı hesapta harcama olmadığı için pazar benchmark'ıdır.
                  <strong> Display/GDN planda yok</strong> — Temmuz'da toplam tıklamanın 60,000'i buradan geliyordu ve niyet taşımıyordu; bu satır kaldırıldığı için
                  toplam tıklama 99,034'ten <strong>39,651'e</strong> düşüyor. Bu bir kayıp değil: kalan tıklamanın tamamı niyetli. Kayıt hedefi <strong>Generic Search</strong>{' '}
                  satırından takip edilmelidir. Etkileşim adedi kampanya amacı bazlı benchmark oranıyla hesaplanmış bir <strong>tahmindir</strong>;
                  hesapta bu metriğin geçmiş kırılımı ölçülü tutulmadığı için ilk ay raporlamaya alınması önerilir.
                  <strong> *Tahmini erişim</strong> platform içi tekilleştirmedir; platformlar arası çakışma ölçülemez.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

// Birleşik görünüm (her iki Hupalupa markası tek sayfada)
export default function HupalupaAgustos2026() {
  return (
    <div className="space-y-16">
      <HupalupaStoreAgustos2026 />
      <HupalupaEglenceAgustos2026 />
    </div>
  );
}
